import { APP_INITIALIZER } from '@angular/core';
import {
    AdobeLaunchConfig,
    adobeLaunchScriptLoader,
} from '@sxm-core/utility-code/typescript/browser-adobe-launch-script-loader';

export function provideAdobeLaunch({
    adobeLaunchConfig,
}: {
    adobeLaunchConfig: AdobeLaunchConfig;
}) {
    if (adobeLaunchConfig.disabled) {
        return [];
    }
    return [
        {
            provide: APP_INITIALIZER,
            useFactory: () => {
                return () => {
                    adobeLaunchScriptLoader(adobeLaunchConfig);
                };
            },
            multi: true,
        },
    ];
}
